import React from 'react'
import styles from '../../styles/solution.module.css';
import SectionTitle from '../common/SectionTitle';
import SectionTitleSub from '../common/SectionTitleSub';
import { KR } from '../../constants/localizations';

export default function SolutionService() {
    return (
        <div className={styles.service}>
            <SectionTitle title={KR.label_solution_service} titleEng={KR.label_solution_service_eng} />
            <SectionTitleSub content={"고객에게 빠르고 정확한 배송을 제공하는 최종 물류 단계로, AR247은 무인 운행 경로와 자동화 운영, 통합 IT 솔루션을 통해 이를 혁신적으로 실현합니다."} contentEng={"As the final logistics stage providing fast and accurate delivery to customers, AR247 innovatively achieves this through unmanned driving routes, automated operations, and integrated IT solutions."} />
            <div className={styles.cardW}>
                <div className={styles.card}>
                    <span>{KR.label_solution_service_route}</span>
                    <span>사업 실증지 주 출입구에서 대기 후<br />
                        주문 매장으로 이동, 복귀 경로 설정 가능</span>
                </div>
                <div className={styles.card}>
                    <span>{KR.label_solution_service_auto_operation}</span>
                    <span>주문, 출발, 복귀, 대기 등 모든 단계가<br />
                        설정에 의해 자동으로 진행</span>
                </div>
                <div className={styles.card}>
                    <span>{KR.label_solution_service_total_solution}</span>
                    <span>자체 개발 주문 어플리케이션과<br />
                        매장 주문 확인 어플리케이션 제공</span>
                </div>
            </div>
        </div>
    )
}
